import { Alert, Loading, Text } from '@acin/ui-core';
import { ApolloError } from '@apollo/client';
import React from 'react';
import { IInternalRegulationDocumentInstance, IInternalRegulationReviewStatus } from '../../../graphql/generated';
import { DocumentListItem } from './DocumentListItem';
import * as SC from './Documents.styled';

export interface DocumentsListProps {
  loading: boolean;
  error: ApolloError | undefined;
  documents: IInternalRegulationDocumentInstance[];
  selectedDocument?: IInternalRegulationDocumentInstance;
  onSelectDocument: (document?: IInternalRegulationDocumentInstance) => void;
  allDocumentsStatus?: IInternalRegulationReviewStatus;
  statusField?: 'obligationReviewStatus' | 'mappingsReviewStatus';
}

export const DocumentsList: React.FC<DocumentsListProps> = (props) => {
  const {
    loading,
    error,
    documents,
    selectedDocument,
    onSelectDocument,
    statusField = 'obligationReviewStatus',
  } = props;

  if (loading) {
    return (
      <SC.LoadingWrapper>
        <Loading />
      </SC.LoadingWrapper>
    );
  }

  if (error) {
    return <Alert status="error" title="Server Error" message="Could not retrieve documents" />;
  }

  if (documents.length === 0) {
    return <Text>No Results</Text>;
  }

  return (
    <SC.List>
      {documents.map((item) => {
        const status = statusField === 'mappingsReviewStatus' ? item.mappingsReviewStatus : item.obligationReviewStatus;
        return (
          <DocumentListItem
            key={item.id}
            id={item.id}
            citation={item.citation || ''}
            name={item.documentDisplayCode ?? item.documentCode ?? ''}
            status={status}
            document={item}
            onSelect={(document) => onSelectDocument(document?.name === 'All Documents' ? undefined : document)}
            activeId={selectedDocument?.id}
          />
        );
      })}
    </SC.List>
  );
};
